import ProductMediaVideo from "./product-media-video";

export default ProductMediaVideo;